import React, {Component} from 'react';
import PrintBNPDoc from './PrintBNPDoc';

class PrintBNPTaxInvoiceDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

  }

  componentDidMount(){

  }

  render() {
    return(
      <PrintBNPDoc
        title={'ใบเสร็จรับเงิน/ใบกำกับภาษี'} 
        doc={'taxinvoice_doc'}
        docNo={this.props.tivNo}
        param={'tiv'}
      >
      </PrintBNPDoc>
    )
  }
}  

export default PrintBNPTaxInvoiceDoc;


// WEBPACK FOOTER //
// ./src/view/print/bnp/PrintBNPTaxInvoiceDoc.js